<template>
  <a v-if="data" @click.prevent="moveToMovie(data.movieid)" href="#">
    <span class="con-img">
      <img :src="data.image | addPostfixAndUrl('210')" alt=""/>
      <span class="tag-rt">
        <img v-if="data.targetage >= 18" src="../../assets/images/common/tag-age21.png" alt=""/>
<!--        <img v-else-if="data.targetage >= 15" src="../../assets/images/common/tag-age15.png" alt=""/>-->
<!--        <img v-else-if="data.targetage >= 12" src="../../assets/images/common/tag-age12.png" alt=""/>-->
<!--        <img v-else src="../../assets/images/common/tag-age-all.png" alt=""/>-->
      </span>
    </span>
    <span class="con-text-wrap">
      <strong class="event-con-tit">{{ data.title }}</strong>
      <span class="event-con-text01 event-td-one">
        <template v-if="data.genre && data.genre.list">
          <template v-for="(genre, genreIndex) in data.genre.list">{{ genre.value }}
            <template v-if="data.genre.list.length > genreIndex + 1">, </template>
          </template>
        </template>
        <template v-if="playTime"><span class="title-dot"></span> {{playTime}}</template>
      </span>

      <span class="event-tr">
        <strong class="event-th">감독</strong>
        <span class="event-td event-td-one">
          <template v-if="data.directors && data.directors.list">
            <template v-for="(director, directorIndex) in data.directors.list">{{ director }}
              <template v-if="data.directors.list.length > directorIndex + 1">, </template>
            </template>
          </template>
        </span>
      </span>
      <span class="event-tr">
        <strong class="event-th">출연진</strong>
        <span class="event-td event-td-one">
          <!--콜린 퍼스(해리), 태런 에저튼(에그시), 사무엘 L. 잭슨(발렌타인)-->
          <template v-if="data.actors && data.actors.list">
            <template v-for="(actor, actorIndex) in data.actors.list">{{ actor }}
              <template v-if="data.actors.list.length > actorIndex + 1">, </template>
            </template>
          </template>
        </span>
      </span>
      <span v-if="data.releasedate" class="event-tr">
        <strong class="event-th">개봉일</strong>
        <span class="event-td">{{ data.releasedate }}</span>
      </span>
      <span class="event-tr">
        <strong class="event-th">줄거리</strong>
        <span class="event-td event-td-five" v-html="synopsis"></span>
      </span>
    </span>
  </a>
</template>

<script>
import { addPostfixAndUrl } from '@/common/utils/common'
import _ from 'lodash'
import { PATH_NAME_PLAYER_MOVIE } from '@/common/resources/router.const'

export default {
  props: {
    data: {
      type: Object
    }
  },
  filters: {
    addPostfixAndUrl
  },
  computed: {
    playTime () {
      return this.data.playtime ? Math.ceil(this.data.playtime / 60) + '분' : ''
    },
    synopsis () {
      const browserName = window.uaInfo.getBrowser().name
      const synopsis = _.get(this.data, 'synopsis', '')
      if (browserName.toUpperCase() === 'IE' && window.uaInfo.getBrowser().major === '10') {
        return synopsis.substr(0, 100) + '...'
      } else {
        return synopsis
      }
    }
  },
  methods: {
    moveToMovie (movieId) {
      this.$router.push({
        name: PATH_NAME_PLAYER_MOVIE,
        query: {
          movieid: movieId
        }
      })
    }
  }
}
</script>
